import { Container, Typography } from "@material-ui/core"
import React from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import ImageListItemBar from '@material-ui/core/ImageListItemBar';
import IconButton from '@material-ui/core/IconButton';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import image1 from './resources/57.png';
import image2 from './resources/64.png';
import image3 from './resources/65.png';
import image4 from './resources/68.png';
import image5 from './resources/69.png';


const Team = () => {

   
    return(
        <Container>
            <Typography variant="h1" component="h2" align='center' >Exemple</Typography>      
            <img className="imgnft" src={image1} />                      
        </Container>
    );
}

export default Team;